export default {"src":"/_next/static/media/check-out-bg.21f5ee76.svg","height":1130,"width":776,"blurWidth":0,"blurHeight":0};